const brandsNavigation = document.getElementById("brandNavigation");
const brandsContainer = document.getElementById("brandList");
const brandsform = document.getElementById("brandsForm");
const searchResults = document.getElementById("searchResults");

const brandSections = ["0123456789", "ABC", "DEF", "GHI", "JKL", "MNÑO", "PQR", "STU", "VWXYZ"];
const brandObject = [];

function findSection(letter) {
  for (let section of brandSections) {
    if (section.includes(letter)) {
      return section;
    }
  }
  return null;
}

total_object.forEach((brandItem) => {
  let firstLetter = brandItem.title.substring(0, 1);
  // Sometimes the first letter is an _ and we need to get the second letter
  if (firstLetter === "_") {
    firstLetter = brandItem.title.substring(1, 2);
  }
  // Since our Brand Sections are uppercase, we need to make sure the first letter is uppercase
  const section = findSection(firstLetter.toUpperCase());

  if (section) {
    if (!brandObject[section]) {
      brandObject[section] = [];
    }
    brandObject[section].push(brandItem);
  }
});

function createListDomAlphabetic() {
  const brandContainer = (brandSection, brandName) => {
    return `
    <div class="brand-container" id="${brandSection}">
        <div class="brand-name">
        ${brandSection}
        </div>
        <ul class="brand-list">
        ${brandName
          .map(
            (fieldValue) => `
            <li class="brand-list-item">
            ${fieldValue.url}
            </li>
        `
          )
          .join("")}
        </div>
    </div>
    `;
  };

  Object.entries(brandObject).forEach(([brandSection, value], i) => {
    if (i === 0) {
      brandSection = brandSection.replaceAll("0123456789", "#123");
    }
    brandsNavigation.innerHTML += `<button class="brand-button" style="color:black" id="${brandSection}">${brandSection}</button>`;
    brandsContainer.innerHTML += brandContainer(brandSection, value);
  });

  function filterBrands(brandsContainer, allbutons, brandItem) {
    allbutons.forEach((brandbutton) => {
      brandbutton.classList.remove("active");
      if (brandItem.id == brandbutton.id) {
        brandbutton.classList.add("active");
      }
    });
    brandsContainer.forEach((brandSelection) => {
      brandSelection.classList.add("hide");
      if (brandItem.id == brandSelection.id) {
        brandSelection.classList.remove("hide");
      }
    });
  }

  const brandButtons = [...document.getElementsByClassName("brand-button")];
  const brandListItems = [...document.getElementsByClassName("brand-container")];
  const showAllButtons = document.getElementById("allBrandsButton");

  showAllButtons.addEventListener("click", function () {
    searchResults.classList.add("hide");
    brandsContainer.classList.remove("hide");
    brandListItems.forEach((brandSelection) => {
      brandSelection.classList.remove("hide");
    });
    brandButtons.forEach((button) => {
      button.classList.remove("active");
    });
  });
  brandButtons.forEach((button) => {
    button.addEventListener("click", function () {
      searchResults.classList.add("hide");
      brandsContainer.classList.remove("hide");
      filterBrands(brandListItems, brandButtons, button);
    });
  });
}

function searchActions() {
  brandsform.addEventListener("submit", searhBrand);
  brandsform.addEventListener("keyup", searhBrand);

  function searhBrand(event) {
    const formValue = document.getElementById("brandsFormInput").value;
    event.preventDefault();
    if (formValue !== "") {
      const searchList = document.getElementById("searchResultsList");
      searchList.innerHTML = ``;
      var searchResultsString = "";
      brandsContainer.classList.add("hide");
      searchResults.classList.remove("hide");

      total_object.forEach((brandItem) => {
        let result = brandItem.title.toLowerCase().includes(formValue.toLowerCase());

        if (result == true) {
          searchResultsString += `
                        <li class="brand-list-item">
                            ${brandItem.url}
                        </li>
                    `;
        }

        if (searchResultsString != "") {
          searchList.innerHTML = searchResultsString;
        } else {
          searchList.innerHTML = `
                        <div class="no-results__message">
                           No se encontró ninguna marca 
                        </div>
                    `;
        }
      });
    } else {
      searchResults.classList.add("hide");
      brandsContainer.classList.remove("hide");
    }
  }
}

createListDomAlphabetic();
searchActions();
